import { Filter } from '../components/Modal/TaskFiltersModal';
import { TaskStatus } from './TaskStatus';
import { SpaceLabel } from './TaskLabel';
import { WorkspaceTaskOrder } from './WorkspaceTaskOrder';
import { WorkspaceView } from './WorkspaceView';

type Workspace = {
  id: number;
  publicId: string;
  name: string;
  visibility: string;
  organizationId: number;
  createdAt: Date;
  updatedAt: Date;
  activeSprintId: number;
  lastTaskId: number;
  TaskStatus: TaskStatus[];
  Labels: SpaceLabel[];
  framework: WorkspaceFramework;
  defaultModule?: WorkspaceDefaultModule;
  estimationType: WorkspaceEstimationType;
  filters: Filter[] | undefined;
  Views: WorkspaceView[];
  TaskOrder: WorkspaceTaskOrder[];
};

export enum WorkspaceFramework {
  scrum = 'scrum',
  kanban = 'kanban',
  none = 'none',
}

export enum WorkspaceDefaultModule {
  triage = 'triage',
  backlog = 'backlog',
  planning = 'planning',
  sprint = 'sprint',
  kanban = 'kanban',
  archive = 'archive',
}

export const getWorkspaceFrameworkDisplayName = (framework: WorkspaceFramework): string => {
  switch (framework) {
    case WorkspaceFramework.scrum:
      return 'Sprint';
    case WorkspaceFramework.kanban:
      return 'Kanban';
    case WorkspaceFramework.none:
      return 'None';
    default:
      return 'Unknown';
  }
};

export enum WorkspaceEstimationType {
  storyPoints = 'storyPoints',
  tshirtSizes = 'tshirtSizes',
}

export default Workspace;
